// extracted by mini-css-extract-plugin
export default {"footer":"Footer__footer___2KrWL","menu":"Footer__menu___iEugO","brand":"Footer__brand___riz2o"};